import styled from "styled-components";

export const ProgramEditingLayoutStyled = styled.div`
  height: 100vh;
  height: 100dvh;

  display: flex;
  flex-direction: column;
`;
